export var LoginUserType;
(function (LoginUserType) {
    LoginUserType[LoginUserType["Unknown"] = 0] = "Unknown";
    LoginUserType[LoginUserType["SupportFull"] = 1] = "SupportFull";
    LoginUserType[LoginUserType["SupportOffices"] = 2] = "SupportOffices";
    LoginUserType[LoginUserType["SalesFull"] = 3] = "SalesFull";
    LoginUserType[LoginUserType["SalesOffices"] = 4] = "SalesOffices";
    LoginUserType[LoginUserType["Client"] = 5] = "Client";
    LoginUserType[LoginUserType["FeedProvider"] = 6] = "FeedProvider";
})(LoginUserType || (LoginUserType = {}));
export const initialUser = {
    loggedIn: false,
    userInfo: null,
    loginUserType: LoginUserType.Unknown,
    userAccess: [],
    redirectUrl: null
};
//--
export class UserInfo {
}
const initialUserInfo = {
    mobile: "",
    email: "",
    firstName: "",
    lastName: ""
};
export const createUserInfo = (item) => {
    let returnObj = {
        mobile: item.mobile,
        email: item.email,
        firstName: item.firstName,
        lastName: item.lastName
    };
    return returnObj;
};
//--
export var EntryType;
(function (EntryType) {
    EntryType[EntryType["NotSet"] = 0] = "NotSet";
    EntryType[EntryType["Agency"] = 1] = "Agency";
    EntryType[EntryType["Office"] = 2] = "Office";
})(EntryType || (EntryType = {}));
export var Role;
(function (Role) {
    Role[Role["NotSet"] = 0] = "NotSet";
    // Brand level
    Role[Role["Brand"] = 1] = "Brand";
    // Office level
    Role[Role["Principal"] = 10] = "Principal";
    Role[Role["Admin"] = 11] = "Admin";
    // Agent level
    Role[Role["Agent"] = 20] = "Agent";
    // Internal Sales
    Role[Role["SalesManager"] = 30] = "SalesManager";
    Role[Role["RegionalAccountManager"] = 31] = "RegionalAccountManager";
    Role[Role["AccountManager"] = 32] = "AccountManager";
    // Internal Support
    Role[Role["SupportManager"] = 40] = "SupportManager";
    Role[Role["Support"] = 41] = "Support";
})(Role || (Role = {}));
//--
const createUserAccess = (item) => {
    let returnObj = {
        type: item.type,
        id: item.id,
        agency: item.agency,
        office: item.office,
        roles: item.roles.map((role) => role)
    };
    return returnObj;
};
export function createAccessFromDto(userAccessDtos) {
    let userOffices = new Array();
    userAccessDtos.map((item) => userOffices.push(createUserAccess(item)));
    return userOffices;
}
